module.exports = __webpack_public_path__ + "img/list-pattern3.f23aea2.svg";